import { useIntl } from 'react-intl';

import queriesConfig from '../Services/queriesConfig';
import Analytics from '../Services/AnalyticsService';
import { extractErrorForToaster } from '../Services/ApiErrorHelpers';
import { Post } from '../Utils/Types/Posts';
import { notify } from '../Utils/NotificationUtils';
import useApiMutation from './useApiMutation';
import { useNotifications } from '@toolpad/core/useNotifications';

export default function usePinUnpinMutation({
  post,
  onSuccess,
}: {
  post: Post;
  onSuccess?: () => void;
}) {
  const notifications = useNotifications();
  const intl = useIntl();

  const { is_pinned: isPinned, id: postId } = post;

  return useApiMutation({
    query: queriesConfig.pinUnpin(postId),
    onSuccess: () => {
      const trackingText = isPinned ? 'Post - Pin' : 'Post - Unpin';

      Analytics.track(trackingText, {
        'Post ID': postId,
      });

      notify(
        notifications,
        intl.formatMessage({ id: isPinned ? 'POSTS.FORM.UNPIN' : 'POSTS.FORM.PIN' }),
      );

      if (onSuccess) onSuccess();
    },
    onError: (error) => {
      notify(notifications, extractErrorForToaster(error, intl));
      notify(notifications, error, 'error');
    },
  });
}
